// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2W1S0","inner":"Form_inner__1L28Q","range":"Form_range__3qXbl","name":"Form_name__3m7gT","actions":"Form_actions__3-Wc3"};